module.exports = __webpack_public_path__ + "img/type_04.1a2f0cf1.png";